<!-- BarChart.vue -->
<template>
  <div>
    <canvas ref="barChart"></canvas>
  </div>
</template>

<script>
import { Chart } from 'chart.js';

export default {
  props: ['chartData', 'options'],
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      const ctx = this.$refs.barChart.getContext('2d');
      new Chart(ctx, {
        type: 'bar',
        data: this.chartData,
        options: this.options,
      });
    },
  },
};
</script>

<style scoped>
/* Optional styling for the chart */
</style>
